import { render } from "./WeTravelButton.vue?vue&type=template&id=1d80dfbc&scoped=true"
import script from "./WeTravelButton.vue?vue&type=script&lang=js"
export * from "./WeTravelButton.vue?vue&type=script&lang=js"

import "./WeTravelButton.vue?vue&type=style&index=0&id=1d80dfbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d80dfbc"]])

export default __exports__